module.exports = __webpack_public_path__ + "static/media/5_Doklad_Oditen_komitet_20150626.253af3b9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/5_Doklad_Oditen_komitet_20150626.pdf
// module id = 188
// module chunks = 0